























































import Vue from "vue";
import StandartCard from "@/components/Card/StandartCard/StandartCard.vue";
import DeviceStateModal from "@/components/Modal/Overview/DeviceStateModal.vue";
import DoughnutChart from "@/components/Chart/DoughnutChart.vue";
import { store } from "@/store/store";
import { mapState } from "vuex";

interface DeviceInformationsStatus {
  name: string;
  color: string;
  status: Float32Array | number;
  count: number;
  should_be_displayed: boolean;
}

interface DeviceStatusCardData {
  device_status: Array<DeviceInformationsStatus>;
  should_display_params: boolean;
  state_to_display: Array<string> | null;
  data: any;
}

export default Vue.extend({
  name: "DeviceStatusCard",
  components: { StandartCard, DoughnutChart, DeviceStateModal },
  data(): DeviceStatusCardData {
    return {
      device_status: [],
      should_display_params: false,
      state_to_display: null,
      data: {}
    };
  },
  mounted(): void {
    this.state_to_display = this.getItemToDisplay;
    this.countDeviceStatus();
    this.calculatePourcentage();
    this.dataCollection();
  },
  methods: {
    countDeviceStatus(): void {
      store.getters.DEVICE_ALL_ID.forEach((device_id) => {
        let device_state: string = store.getters.DEVICE_BY_ID[device_id].state;
        let state_name: string = store.getters.STATE_BY_ID[device_state].name;
        let device_status = this.device_status.find((status) => status.name === state_name);
        if (device_status) device_status.count += 1;
        else
          this.device_status.push({
            name: state_name,
            status: 0,
            count: 1,
            color: store.getters.STATE_BY_ID[device_state].color,
            should_be_displayed:
              this.state_to_display && this.state_to_display.find((state) => state_name === state) ? true : false
          });
      });
    },
    calculatePourcentage(): void {
      const device_len = store.getters.DEVICE_ALL_ID.length;
      this.device_status.forEach((device_status) => {
        device_status.status = (device_status.count / device_len) * 100;
      });
      this.device_status.sort(
        (a: DeviceInformationsStatus, b: DeviceInformationsStatus) => (b.status as number) - (a.status as number)
      );
    },
    shouldDisplayParamModal(): void {
      this.should_display_params = true;
    },
    shouldCloseParamModal(): void {
      this.should_display_params = false;
    },
    setItemToDisplay(result: Array<string>): void {
      localStorage.setItem("state_to_display", JSON.stringify(result));
      this.state_to_display = result;
      this.device_status = [];
      this.countDeviceStatus();
      this.calculatePourcentage();
      this.dataCollection();
      this.shouldCloseParamModal();
    },
    dataCollection(): any {
      this.data = {
        fontColor: "#ffffff",
        labels: this.device_status.filter((device) => device.should_be_displayed).map((device) => device.name),
        datasets: [
          {
            label: "STATUT DES APPAREILS",
            data: this.device_status.filter((device) => device.should_be_displayed).map((device) => device.count),
            backgroundColor: this.device_status
              .filter((device) => device.should_be_displayed)
              .map((device) => device.color)
          }
        ]
      };
    }
  },
  computed: mapState({
    getItemToDisplay(): Array<string> {
      const item_to_display = localStorage.getItem("state_to_display");
      if (item_to_display) return JSON.parse(item_to_display);
      const states = store.getters.STATE_ALL_ID.map((state_id) => store.getters.STATE_BY_ID[state_id].name);
      localStorage.setItem("state_to_display", JSON.stringify(states));
      return states;
    },
    view(): string | null {
      return this.$store.state.view;
    }
  }),
  watch: {
    view: {
      handler(): void {
        this.device_status = [];
        this.countDeviceStatus();
        this.calculatePourcentage();
        this.dataCollection();
      }
    }
  }
});
